import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class LoggedInGuard  {
  constructor(
    private router: Router,
    private auth: AuthService,
  ) {}

  canActivate(): Observable<boolean> {
    return new Observable((observer) => {
      this.auth.loggedIn.subscribe((isLoggedIn) => {
        if (!isLoggedIn && !this.auth.isLoggingOut()) {
          this.router.navigateByUrl('/login');
        }

        observer.next(isLoggedIn);
      });
    });
  }
}
